<template>
	<b-modal id="modal-addfolder" title="Add a folder">
		<span class="close" @click="onClose">
			<x-icon size="1.25x" class="custom-class"></x-icon>
		</span>
		<div class="">
			<b-form @submit.prevent="addFolder">
				<label class="sr-only" for="inline-form-input-name"
					><span>Folder name</span>
				</label>
				<b-input
					id="inline-form-input-name"
					class=""
					placeholder="Research #1"
					v-model="folder.title"
					minLength="1"
					maxLength="140"
				></b-input>

				<b-button @click="addFolder" variant="primary">Save folder</b-button>
			</b-form>
		</div>
	</b-modal>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons';
import tt from '@/lib/trim-text.js';
export default {
	components: {
		XIcon,
		CheckIcon,
	},
	data: function () {
		var obj = {
			lock: false,
			folder: {
				title: '',
				color: 2,
			},
		};
		return obj;
	},
	computed: {},
	methods: {
		onClose: function () {
			this.$bvModal.hide('modal-addfolder');
		},
		addFolder: function () {
			this.lock = true;
			var obj = {
				title: this.folder.title,
			};
			this.$store.dispatch('folder/addFolder', obj).then((data) => {
				this.$bvModal.hide('modal-addfolder');
				this.reset();
			});
		},
		reset: function () {
			this.lock = false;
			this.folder.title = '';
		},
	},
	mounted: function () {},
};
</script>

<style lang="scss">
#modal-addfolder___BV_modal_outer_ {
	.modal-footer {
		display: none;
	}
	.modal-dialog {
		max-width: 420px;
	}
}
</style>
